import type { AppSectionId } from '@/features/app/constants/sections';
import { APP_SECTION } from '@/features/app/constants/sections';

/** Rotas da aplicação (evitar strings soltas no código). */
export const ROUTES = {
  ROOT: '/',
  HOME: '/home',
  LOGIN: '/login',
  SIGNUP: '/cadastro',
  AUTH_ONBOARDING: '/onboarding',
  ADMIN: '/admin',
  APP: '/app',
  CHOOSE_PLAN: '/escolher-plano',
  VERIFY_SUBSCRIPTION: '/confirmar-assinatura',
} as const;

const APP_SECTION_IDS = new Set<string>(Object.values(APP_SECTION));

/** `/app/{secção}` — deep link e navegação programática. */
export function appSectionPath(section: AppSectionId): string {
  return `${ROUTES.APP}/${section}`;
}

/** Extrai a secção da URL sob `/app/...` ou `null` se for só `/app`. */
export function parseAppSectionFromPathname(pathname: string): AppSectionId | null {
  const prefix = `${ROUTES.APP}/`;
  if (!pathname.startsWith(prefix)) return null;
  const seg = pathname.slice(prefix.length).split('/')[0];
  if (!seg || !APP_SECTION_IDS.has(seg)) return null;
  return seg as AppSectionId;
}
